import { API_URL } from '../config.js'

export const LOGIN = `${API_URL}/api/login`;
export const REGISTER = `${API_URL}/api/register`;
export const ADDTASK = `${API_URL}/api/createTask`;
export const GETALLTASK = `${API_URL}/api/tasklist`;
export const DELETETASK = `${API_URL}/api/deletetask`;
export const MARKREADTASK = `${API_URL}/api/marktask`;